export default "__VITE_ASSET__cVGGXn_D__"